export default __webpack_public_path__ + "static/media/008-bottles.3ccbf7d9.svg";